import React from 'react';

// types and state
import {
  create_religion,
  get_religions,
  update_religion
} from '@/service/api/religion';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { ErrorWarning } from '@/store/types/misc';

// components
import Items from '../misc/Items';
import Create from '../misc/Create';
import HeaderTitle from '../misc/HeaderTitle';
import Loading from '../misc/Loading';

type IDataSet = {
  name: string;
  id: string;
};
type IErrorDataSet = {
  name: ErrorWarning;
  id: string;
};

const Religion = () => {
  const dispatch = useAppDispatch();
  const religions = useAppSelector(({ religion }) => religion.religions);
  const loading = useAppSelector(({ religion }) => religion.loading);
  const update = useAppSelector(({ religion }) => religion.update);
  const [show, showSet] = React.useState<boolean>(false);
  const [data, dataSet] = React.useState<IDataSet>({
    id: '',
    name: ''
  });
  const [error, errorSet] = React.useState<IErrorDataSet>({
    id: '',
    name: ''
  });

  const onLoad = React.useCallback(() => {
    get_religions(dispatch);
  }, [dispatch]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  return (
    <section className="w-[32%] h-[50vh] my-4  bg-[white] shadow-sm mx-[4px] border px-3 py-3 rounded-lg overflow-hidden overflow-y-auto">
      <HeaderTitle
        title="Religion [R]"
        onClick={() => showSet(true)}
        loading={update}
      />
      <ul>
        {loading ? (
          <Loading />
        ) : (
          religions.map((item) => (
            <Items
              key={item.id}
              item={item}
              onEdit={(res) => {
                dataSet({ id: res.id?.toString(), name: res.name });
                showSet(true);
              }}
            />
          ))
        )}
      </ul>
      <Create
        name="name"
        value={data.name}
        err={error.name}
        onChange={(e) => {
          const { name, value } = e.target;
          dataSet((prev) => ({ ...prev, [name]: value }));
          errorSet((prev) => ({ ...prev, [name]: '' }));
        }}
        placeholder="Religion"
        visible={show}
        handleCancel={() => {
          showSet(false);
          dataSet({ id: '', name: '' });
        }}
        handleOk={() => {
          if (data.id && data.name) {
            update_religion(dispatch, data);
          } else if (data.name && !data.id) {
            create_religion(dispatch, data);
          }
          showSet(false);
          dataSet({ id: '', name: '' });
        }}
      />
    </section>
  );
};

export default Religion;
